import moment from "moment";
import { Nav } from "react-bootstrap";
import React, { Fragment, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import SuperAgentBilling from "../../../components/Transaction/SuperAgentBilling";
import { formatNumber } from "../../../utils/convertToNumber";
import excelExport from "../../../utils/excelExport";
import Loading from "../../../components/Loading";
import { USER_ROLE_EMPLOYEE } from "../../../common/constants";
import { getTransactions } from "../../../redux2/transaction/transactionSlice";
import AgentTransaction from "./AgentTransaction";
import StatCard from "../../Billing/StatCard";
import TransactionBankList from "./TransactionBankList";
import AnalyticsCards from "./AnalyticsCards";
import TransactionCard from "./TransactionCard";
import FinancialDashboardModal from "../../../components/Modals/FinancialDashboardModal";
import { getTransactionReport } from "../../../services/report";

const TransactionList = ({ query }) => {
  const { transactions, isLoading } = useSelector((state) => state.transaction);
  const { user } = useSelector((state) => state.auth);
  const [current, setCurrent] = useState("Overall Billing");
  const [currentPage, setCurrentPage] = useState(1);
  const [show, setShow] = useState(false);

  const dispatch = useDispatch();

  const NavData = [
    { name: "Overall Billing" },
    { name: "Super Agent Billing" },
  ];

  query.page = currentPage || 1;
  query.limit = 10;

  const renderTransaction = () => {
    switch (current) {
      case "Overall Billing":
        return (
          <AgentTransaction
            transactions={transactions}
            currentPage={currentPage}
            setCurrentPage={setCurrentPage}
          />
        );
      case "Super Agent Billing":
        return <SuperAgentBilling billings={transactions?.superTransactions} />;
      default:
        return (
          <AgentTransaction
            transactions={transactions}
            currentPage={currentPage}
            setCurrentPage={setCurrentPage}
          />
        );
    }
  };

  async function handleExport() {
    let report = await getTransactionReport(query);

    let fileName = "Transaction Report " + moment().format("DD-MM-YYYY");

    let data = report?.transactions?.map((transaction, index) => {
      return {
        "S/N": index + 1,
        Type: transaction?.type,
        "Company Name": transaction?.company ? transaction?.company?.name : "-",
        "Transaction ID": transaction.transaction
          ? transaction.transaction
          : "-",
        "Ticket Number": transaction?.ticketNumber?.join(", "),
        "Base Amount": +transaction?.amount,
        "Service Charge": transaction.serviceCharge || 0,
        "Payment Method": transaction.bank,
        "Refunded Amount": transaction?.refundedAmount || 0,
        "Voided Ticket": transaction?.voidedTicketNumber?.join(", "),
        "Refunded Ticket":
          transaction?.type === "refund"
            ? transaction?.details?.ticketNumbers
            : "-",
        Tax: transaction?.tax || 0,
        Penalty: transaction?.penalty || 0,
        "Fare Difference": transaction?.exchangeDifference || 0,
        Channel: transaction?.channel,
        "Paid By": transaction?.paidBy,
        "Created At": moment(transaction.createdAt).format("MMM DD, YYYY"),
      };
    });
    let fileName2 = "Super Billing Report " + moment().format("DD-MM-YY");
    let superAgentData = transactions?.superTransactions?.map(
      (transaction, index) => {
        return {
          "S/N": index + 1,
          Type: transaction?.type,
          "Transaction ID": transaction.transaction
            ? transaction.transaction
            : "-",
          "Ticket Number": transaction?.ticketNumber?.join(", "),
          "Base Amount": +transaction?.amount,
          "Service Charge": transaction.serviceCharge || 0,
          "Payment Method": transaction.bank,
          "Refunded Amount": transaction?.refundedAmount || 0,
          "Voided Ticket": transaction?.voidedTicketNumber?.join(", "),
          Tax: transaction?.tax || 0,
          Penalty: transaction?.penalty || 0,
          "Fare Difference": transaction?.exchangeDifference || 0,
          Channel: transaction?.channel,
          "Paid By": transaction?.paidBy,
          "Created At": moment(transaction.createdAt).format("MMM DD, YYYY"),
        };
      }
    );

    excelExport(data, fileName);
    if (transactions?.superTransactions?.length > 0) {
      excelExport(superAgentData, fileName2);
    }
  }

  useEffect(() => {
    dispatch(getTransactions(query));
  }, [query, dispatch, currentPage]);

  if (isLoading) {
    return <Loading />;
  }

  return (
    <Fragment>
      {user?.role !== USER_ROLE_EMPLOYEE && (
        <>
          {user?.showBilling && (
            <AnalyticsCards analytics={transactions?.analytics} />
          )}
          {transactions?.depositByBank?.length > 0 && (
            <Fragment>
              <h1>
                <span className="px-2 py-4 text-2xl font-semibold">
                  Bank Deposit Stat
                </span>
              </h1>
              {TransactionBankList(
                transactions?.depositByBank,
                formatNumber
              )?.map(({ icon, color, title, data }, index) => (
                <StatCard
                  key={index}
                  icon={icon}
                  color={color}
                  title={title}
                  data={data}
                />
              ))}
            </Fragment>
          )}
          <TransactionCard items={transactions?.data} />
        </>
      )}

      <div className="flex-wrap my-4 d-flex justify-content-between align-items-center">
        <div className="mt-3 mb-4 rounded shadow-sm card-tabs mt-sm-0 mb-xxl-0">
          <Nav as="ul" className="nav nav-tabs">
            {NavData.map(({ name }, index) => (
              <Nav.Item
                as="li"
                key={index}
                className="nav-item"
                onClick={() => setCurrent(name)}
              >
                <Nav.Link
                  className="px-4 py-2 text-4xl font-bold nav-link"
                  eventKey={name}
                  active={current === name}
                >
                  {name}
                </Nav.Link>
              </Nav.Item>
            ))}
          </Nav>
        </div>

        {user?.showBilling && (
          <FinancialDashboardModal
            show={show}
            onHide={() => setShow(false)}
            financialData={{
              depositByBank: transactions?.allDepositByBank,
              companyTotalSales: transactions?.allTotalSales,
            }}
          />
        )}

        <div className="flex gap-2 items-center mx-4">
          <div className="inline-block">
            <div
              className="mb-4 text-white btn bg-main hover:bg-main-800 border-main-100 mb-xxl-0"
              onClick={() => setShow(true)}
            >
              Financial Dashboard
            </div>
          </div>
          <div
            className="mb-4 text-white btn bg-main hover:bg-main-800 border-main-100 mb-xxl-0"
            onClick={handleExport}
          >
            <i className="far fa-file-word me-2"></i>Generate Report
          </div>
        </div>
      </div>

      <div>
        <h3 className="text-2xl font-black text-primary">Transaction</h3>
        {renderTransaction()}
      </div>
    </Fragment>
  );
};

export default TransactionList;
